var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-title"},[_c('span',[_vm._v("——")]),_vm._v(" "),_c('span',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"Logo"}})]),_vm._v(" "),_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',[_vm._v("——")])])
}
var staticRenderFns = []

export { render, staticRenderFns }